import React from 'react';
import styled from 'styled-components';
import useSearch from '../../../../util/search/useSearch';
import { H1, spacingHelper } from '../../../../@nitty';

const Header = () => {
    const { searchQuery } = useSearch();

    return (
        <HeaderContainer>
            <H1>Privacy Policy</H1>
        </HeaderContainer>
    );
};

const HeaderContainer = styled.div`
    display: flex;
    padding: ${spacingHelper("0 medium")};
    margin: ${spacingHelper('1rem auto 1.5rem')};

    ${({ theme }) => theme.layoutBreakpoints.medium} {
        margin: ${spacingHelper('2rem auto 2.5rem')};
        max-width: calc(71.375rem + ${spacingHelper("medium")});
        padding: ${spacingHelper("0 extraLarge")};
    }
`

export default Header;
